import NumberInput from '@components/input/number.input.jsx';
import Button from '@components/buttons/button.jsx';
import toast from 'react-hot-toast';
import {
  CheckCircle,
  ExclamationCircle,
  PaperPlane,
} from 'flowbite-react-icons/solid';
import { useState } from 'preact/hooks';
import useTiltifyConfig from '@hooks/useTiltifyConfig.js';
import PropTypes from 'prop-types';

SendTestDonation.propTypes = {
  instructions: PropTypes.string.isRequired,
  sendButtonText: PropTypes.string,
  donationType: PropTypes.string,
};

export default function SendTestDonation({
  instructions,
  sendButtonText = 'Send',
  donationType = 'alert',
}) {
  const [testDonationAmount, setTestDonationAmount] = useState(null);
  const [canSendTestAlert, setCanSendTestAlert] =
    useState(!!testDonationAmount);

  const tiltifyConfig = useTiltifyConfig();

  function sendTestAlert() {
    setCanSendTestAlert(false);
    const testAlertURL =
      import.meta.env.VITE_ALERT_SERVICE_URI + '/generateTestAlert';

    const data = {
      amount: testDonationAmount,
      campaignID: tiltifyConfig.tiltifyCampaignID,
      testComment: 'This is a test donation',
      type: donationType === 'message' ? 'tts' : 'alert',
    };

    fetch(testAlertURL, {
      method: 'POST',
      body: JSON.stringify(data),
    })
      .then((response) => {
        if (response.status !== 200)
          toast(
            <>
              <ExclamationCircle />
              <span>Failed to send test {donationType}</span>
            </>,
            {
              position: 'top-center',
              className: 'alert-error text-white',
            }
          );
        else
          toast(
            <>
              <CheckCircle />
              <span>Test {donationType} sent</span>
            </>,
            {
              position: 'top-center',
              className: 'alert-success text-white',
            }
          );

        setCanSendTestAlert(true);
      })
      .catch((err) => {
        console.error(err);
        setCanSendTestAlert(true);
      });
  }

  function testDonationAmountChanged(e) {
    setTestDonationAmount(e.target.valueAsNumber);
    setCanSendTestAlert(e.target.valueAsNumber > 0);
  }

  return (
    <article className="prose text-sm my-6">
      <div className="divider" />

      <div className="flex w-full items-center mb-10">
        <NumberInput
          className="flex-grow"
          inputClassName="input-lg"
          name="minAudio"
          value={testDonationAmount}
          placeholder="5.00"
          onChange={testDonationAmountChanged}
          isCurrency={true}
          maxLength={4}
          minValue={0}
          labelText="Test Amount"
          description={instructions}
        />

        <div className="tooltip" data-tip={sendButtonText}>
          <Button
            onClick={sendTestAlert}
            mode="button"
            className="ml-2 btn-lg"
            disabled={!canSendTestAlert}
          >
            <PaperPlane className="rotate-90" />
          </Button>
        </div>
      </div>
    </article>
  );
}
